import { render, staticRenderFns } from "./PageTable.vue?vue&type=template&id=096947ba&scoped=true&"
import script from "./PageTable.vue?vue&type=script&lang=js&"
export * from "./PageTable.vue?vue&type=script&lang=js&"
import style0 from "./PageTable.vue?vue&type=style&index=0&id=096947ba&scoped=true&lang=css&"
import style1 from "./PageTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096947ba",
  null
  
)

export default component.exports